import React from 'react';
import styles from './Card.module.scss';

const Card = ({className = '', children, id = ''}) => {
    return (
        <div id={id} className={`${styles.card} ${className}`}>
            {children}
        </div>
    )
}

export default Card;